import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, ShoppingBag, CreditCard, Search } from 'lucide-react';

const integrations = [
    { name: 'WhatsApp', icon: MessageCircle, color: 'text-green-500' },
    { name: 'iFood', icon: ShoppingBag, color: 'text-red-500' },
    { name: 'Pagamentos', icon: CreditCard, color: 'text-blue-500' },
    { name: 'Google', icon: Search, color: 'text-white' },
];

const Integrations: React.FC = () => {
    return (
        <section className="py-32 px-6 bg-background">
            <div className="max-w-[1200px] mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
                    <div className="space-y-8">
                        <h2 className="text-4xl md:text-5xl font-black text-white tracking-tighter">
                            Conecta-se a tudo o que <br />
                            <span className="text-primary truncate">você já usa.</span>
                        </h2>
                        <p className="text-xl text-secondary leading-relaxed">
                            O Garçom Digital não é uma ilha. Ele se integra nativamente com as ferramentas
                            que já fazem parte do seu dia a dia, automatizando o fluxo de dados entre plataformas.
                        </p>
                        <div className="flex flex-wrap gap-4 pt-4">
                            {['API Aberta', 'Webhooks', 'SDK'].map(tag => (
                                <span key={tag} className="px-4 py-2 rounded-full border border-white/10 text-xs font-bold text-white/50 uppercase tracking-widest">
                                    {tag}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        {integrations.map((item, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, scale: 0.8 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: i * 0.1 }}
                                className="aspect-square bg-white/[0.02] border border-white/5 rounded-3xl p-8 flex flex-col items-center justify-center gap-4 group hover:bg-white/[0.05] hover:border-white/10 transition-all cursor-default"
                            >
                                <div className={`p-4 rounded-2xl bg-white/5 group-hover:scale-110 transition-transform ${item.color}`}>
                                    <item.icon className="w-8 h-8" />
                                </div>
                                <span className="text-white font-bold opacity-40 group-hover:opacity-100 transition-opacity">
                                    {item.name}
                                </span>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Integrations;
